import { combineReducers } from 'redux-immutable'
import confidentialListReducer from './confidential-list-reducer'
import confidentialGetReducer from './confidential-get-reducer'
import confidentialEditReducer from './confidential-edit-reducer'
import confidentialCreateReducer from './confidential-create-reducer'
import confidentialDeactivateReducer from './confidential-deactivate-reducer'
import confidentialExportReducer from './confidential-export-reducer'
import confidentialImportReducer from './confidential-import-reducer'

export default combineReducers({
  confidentialList: confidentialListReducer,
  confidentialGet: confidentialGetReducer,
  confidentialEdit: confidentialEditReducer,
  confidentialExport: confidentialExportReducer,
  confidentialImport: confidentialImportReducer,
  confidentialCreate: confidentialCreateReducer,
  confidentialDeactivate: confidentialDeactivateReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/confidential/index.js